import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/tariff/tariff.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TariffListNameCell } from './tariff-list-name.cell';
import { TariffListNameHeader } from './tariff-list-name.header';

export const TariffListNameColumn: IdentifiedColumnDef<
  TariffModel,
  TariffModel['name']
> = {
  enableSorting: true,
  header: TariffListNameHeader,
  cell: TariffListNameCell,
};
